interface VendorTimezoneLocation {
  id: string
  timezone: string
}

/** Use the basket location, or a stable provisional location before selection. */
export function resolveVendorMenuTimezone(
  locations: readonly VendorTimezoneLocation[],
  selected: VendorTimezoneLocation | null,
): string | undefined {
  // The location store is shared across vendor pages. Ignore a previous vendor's selection.
  const matching = selected && locations.find((location) => location.id === selected.id)
  const fallback = locations.reduce<VendorTimezoneLocation | undefined>((first, location) => {
    if (!first || location.id < first.id) {
      return location
    }

    return first
  }, undefined)
  const timezone = (matching || fallback)?.timezone
  try {
    if (!timezone) {
      return undefined
    }

    new Intl.DateTimeFormat('en', { timeZone: timezone })

    return timezone
  } catch {
    return undefined
  }
}
